import { swiper, swiperSlide } from 'vue-awesome-swiper';
import loaderMixin from '@/mixins/loader';
import topComment from './top-comment/top-comment.vue';

export default {
  props: {
    widget: Object,
  },
  mixins: [
    loaderMixin,
  ],
  components: {
    swiper,
    swiperSlide,
    topComment,
  },
  data() {
    return {
      rightDis: false,
      leftDis: true,
      swiperOptions: {
        spaceBetween: 0,
        autoplay: 10 * 1000,
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
        onTransitionStart: (swp) => {
          const ax = swp.activeIndex % this.lastIndex;
          this.leftDis = (ax === 1);
          this.rightDis = (ax === 0);
        },
      },
    };
  },
  computed: {
    obj() {
      return !this.widget ? {} : this.widget;
    },
    items() {
      return this.widget.widgetTopComments || [];
    },
    lastIndex() {
      return this.items.length;
    },
    prevArrowModifiers() {
      return {
        'market-top-comments__arrow': true,
        'market-top-comments__arrow--left': true,
      };
    },
    nextArrowModifiers() {
      return {
        'market-top-comments__arrow': true,
        'market-top-comments__arrow--right': true,
      };
    },
  },
  methods: {
    prevSlide() {
      this.$refs.swiper.swiper.slidePrev();
    },
    nextSlide() {
      this.$refs.swiper.swiper.slideNext();
    },
  },
  watch: {
    widget(val) {
      if (val) {
        this.loaderRemove();
      }
    },
  },
  mounted() {
    if (!this.widget) {
      this.loaderAdd();
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-top-comments/market-top-comments.js